export const imgATM: string = (() => {
    return '/Areas/Locations/Images/Shared/map_atm_unselected.png';
})();

export const imgATMSelected: string = (() => {
    return '/Areas/Locations/Images/Shared/map_atm_selected.png';
})();

export const imgBranch: string = (() => {
    return '/Areas/Locations/Images/Shared/map_branch_unselected.png';
})();

export const imgBranchSelected: string = (() => {
    return '/Areas/Locations/Images/Shared/map_branch_selected.png';
})();

export const imgCurrentLocation: string = (() => {
    return '/Areas/Locations/Images/Shared/map_current_location.png';
})();